import Vue from "vue";

Vue.component("CertificationForm191001", () =>
  import("@/components/Certification/191001/CertificationForm")
);
// Vue.component("Certification200101", () =>
//   import("@/components/certification/200101/Form")
// );
